import React from 'react';
import { ErrorTypeEnum } from '@css-xp/base/error-page';
import { getWACUrl } from '@css-xp/ppc-utils';
import { getPartnerServiceDeskUrlForGenericHelp, trackPartnerServiceDeskClick } from '@css-xp/ppc-navigation';

function getComponentSpecificDescriptionForLine1(componentName: string) {
  // FIXME :: use ErrorComponents.<componentName>.name here,
  // currently it's causing issues in testing
  switch (componentName) {
    case ErrorTypeEnum.NOT_FOUND:
      return "We're having trouble finding the page you requested.";
    case ErrorTypeEnum.SERVER_ERROR:
      return 'An unrecoverable system error has occurred.';
    case ErrorTypeEnum.UNAUTHORIZED:
      return 'You are not authorized to access this section of Partner Purchasing Center.';
    default:
      return '';
  }
}

const getComponentSpecificDescriptionForLine3 = (componentName: string) => {
  switch (componentName) {
    case ErrorTypeEnum.UNAUTHORIZED:
      return (
        <>
          Know more about Atlassian’s Partner Program{' '}
          <a target="_blank" rel="noopener noreferrer" href={`${getWACUrl()}/partners`}>
            here
          </a>
          .
        </>
      );
    default:
      return '';
  }
};

export function withErrorWrapper<T>(WrappedComponent: React.FC<T>) {
  const componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const title = "We're not sure what went wrong";
  const description = (
    <p>
      {getComponentSpecificDescriptionForLine1(componentName)} Try refreshing the page. If this keeps happening, contact{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={getPartnerServiceDeskUrlForGenericHelp()}
        onClick={trackPartnerServiceDeskClick}
      >
        Partner service desk
      </a>
      . {getComponentSpecificDescriptionForLine3(componentName)}
    </p>
  );

  const ComponentWrapper = (props: T) => {
    return <WrappedComponent {...props} description={description} title={title} />;
  };

  ComponentWrapper.displayName = `WithErrorWrapper(${componentName})`;

  return ComponentWrapper;
}
